import React from 'react'
import { PATROCINADORES } from '../../dados/evento'

/**
 * 8ª dobra — patrocinadores por cota.
 *
 * A hierarquia das cotas é o conteúdo desta seção: quem pagou Ouro comprou
 * destaque sobre quem pagou Apoio. Se todos os logos saíssem do mesmo tamanho,
 * a seção estaria descrevendo errado o que foi vendido. Por isso o tamanho do
 * bloco cai de Ouro para Apoio (ver .cota-* em componentes.css).
 *
 * Nenhum dos 7 logos foi entregue. O placeholder é o nome em caixa alta dentro
 * de uma moldura — legível e claramente provisório, em vez de retângulo cinza
 * que parece imagem quebrada. Cada logo entra pelo campo `logo` no Builder.
 */
export default function SecaoPatrocinadores({
  chamada = 'Patrocinadores',
  cotas = PATROCINADORES,
}) {
  return (
    <section className="secao secao-patrocinadores noite" id="patrocinadores">
      <div className="container-site">
        {/* PAINEL ÚNICO, contornado — na arte aprovada as quatro cotas moram
            dentro de uma mesma moldura, com o título centrado em cima e um fio
            saindo para cada lado. Antes eram quatro blocos soltos sob um
            cabeçalho de seção comum. O painel é o que faz o conjunto ler como
            "a placa de patrocinadores" em vez de mais uma grade de cartões. */}
        <div className="patrocinadores-painel">
          {/* O NAUTA SAIU DAQUI em 12/08. Ele flutuava na quina do painel e, a
              1440px, era cortado ao meio pela margem esquerda da dobra — meio
              capacete aparecendo, o resto fora da tela. Ele já é o personagem
              de cinco outras dobras; aqui competia com as logos numa placa cuja
              única função é dizer quem pagou. */}

          <h2 className="patrocinadores-titulo">{chamada}</h2>

          <div className="cotas">
          {cotas.map((cota) => (
            <section
              key={cota.cota}
              className={`cota cota-${cota.cota.toLowerCase()}`}
              aria-label={`Cota ${cota.cota}`}
            >
              {/* "EXCLUSIVA" SAIU em 12/08, a pedido do cliente: o selo
                  dourado "OURO" já diz a posição da cota sozinho, e o texto
                  extra ao lado só repetia com mais palavras o que a cor e a
                  cota já comunicam. */}
              <h3 className="cota-titulo">{cota.cota}</h3>
              <ul className="cota-lista lista-limpa">
                {cota.empresas.map((empresa) => (
                  <li key={empresa.nome} className="cota-empresa">
                    {empresa.logo ? (
                      <img src={empresa.logo} alt={empresa.nome} loading="lazy" />
                    ) : (
                      <span className="cota-nome">{empresa.nome}</span>
                    )}
                  </li>
                ))}
              </ul>
            </section>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
